import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

// Actions
import * as SharedDataActions from './sharedData.actions';

// Models
import { JobFunction } from "src/app/contacts/model/jobFunction.model";
import { Salutation } from "src/app/contacts/model/salutation.model";
import { AddressClass } from "src/app/modules/shared/model/addressClass.model";
import { AddressType } from "src/app/modules/shared/model/addressType.model";
import { Country } from "src/app/modules/shared/model/country.model";
import { Language } from "src/app/modules/shared/model/language.model";
import { Source } from "src/app/modules/shared/model/source.model";

// Services
import { ContactHttpService } from 'src/app/modules/shared/services/contact.http.service';
import { CoreHttpService } from 'src/app/modules/shared/services/core.http.service';

@Injectable()
export class SharedDataEffects {
    constructor(
        private action$: Actions, 
        private contactHttpService: ContactHttpService,
        private coreHttpService: CoreHttpService) { }

    GetJobFunctions$: Observable<Action> = createEffect(() =>
        this.action$.pipe(
            ofType(SharedDataActions.beginGetJobFunctions),
            mergeMap(() =>
                this.contactHttpService.getContactRoles().pipe(
                    map((jobFunctions: JobFunction[]) => {
                        return SharedDataActions.successGetJobFunctions({ payload: jobFunctions });
                    }),
                    catchError(() => [])
                )
            )
        )
    );

    GetSalutations$: Observable<Action> = createEffect(() =>
        this.action$.pipe(
            ofType(SharedDataActions.beginGetSalutations),
            mergeMap(() =>
                this.contactHttpService.getSalutations().pipe(
                    map((salutations: Salutation[]) => {
                        return SharedDataActions.successGetSalutations({ payload: salutations });
                    }),
                    catchError(() => [])
                )
            )
        )
    );

    GetAddressClasses$: Observable<Action> = createEffect(() =>
        this.action$.pipe(
            ofType(SharedDataActions.beginGetAddressClasses),
            mergeMap(() =>
                this.coreHttpService.getAllAddressClasses().pipe(
                    map((addressClasses: AddressClass[]) => {
                        return SharedDataActions.successGetAddressClasses({ payload: addressClasses });
                    }),
                    catchError(() => [])
                )
            )
        )
    );

    GetAddressTypes$: Observable<Action> = createEffect(() =>
        this.action$.pipe(
            ofType(SharedDataActions.beginGetAddressTypes),
            mergeMap(() =>
                this.coreHttpService.getAllAddressTypes().pipe(
                    map((addressTypes: AddressType[]) => {
                        return SharedDataActions.successGetAddressTypes({ payload: addressTypes });
                    }),
                    catchError(() => [])
                )
            )
        )
    );

    GetCountries$: Observable<Action> = createEffect(() =>
        this.action$.pipe(
            ofType(SharedDataActions.beginGetCountries),
            mergeMap(() =>
                this.coreHttpService.getAllCountries().pipe(
                    map((countries: Country[]) => {
                        return SharedDataActions.successGetCountries({ payload: countries });
                    }),
                    catchError(() => [])
                )
            )
        )
    );

    GetLanguages$: Observable<Action> = createEffect(() =>
        this.action$.pipe(
            ofType(SharedDataActions.beginGetLanguages),
            mergeMap(() =>
                this.coreHttpService.getAllLanguages().pipe(
                    map((languages: Language[]) => {
                        return SharedDataActions.successGetLanguages({ payload: languages });
                    }),
                    catchError(() => [])
                )
            )
        )
    );

    GetSources$: Observable<Action> = createEffect(() =>
        this.action$.pipe(
            ofType(SharedDataActions.beginGetSources),
            mergeMap(() =>
                this.coreHttpService.getAllSources().pipe(
                    map((sources: Source[]) => {
                        return SharedDataActions.successGetSources({ payload: sources });
                    }),
                    catchError(() => [])
                )
            )
        )
    );
}